import { Check, Moon } from "lucide-react";
import { THEMES, useTheme } from "@/lib/theme";

export const ThemeOptions = ({ grid = false }) => {
  const { themeId, setThemeId } = useTheme();
  return (
    <div className={grid ? "grid grid-cols-1 sm:grid-cols-2 gap-2" : "space-y-0.5"} data-testid="theme-options">
      {Object.entries(THEMES).map(([id, t]) => (
        <button key={id} type="button" data-testid={`theme-option-${id}`} onClick={() => setThemeId(id)}
          className={`w-full flex items-center gap-3 px-2 py-2 rounded-xl text-sm transition-colors ${id === themeId ? "bg-t-surface" : "hover:bg-t-bg"} ${grid ? "border border-t-line px-3 py-3" : ""}`}>
          <div className="flex -space-x-1.5">
            {[t.base.primary, t.base.c2, t.base.c3, t.base.surface].map((c) => (
              <span key={c} className="h-5 w-5 rounded-full border-2 border-t-card" style={{ backgroundColor: c }} />
            ))}
          </div>
          <span className="flex-1 text-left font-medium text-t-ink">{t.name}</span>
          {t.dark && <Moon className="h-3.5 w-3.5 text-t-muted" />}
          {id === themeId && <Check className="h-4 w-4 text-t-primary" />}
        </button>
      ))}
    </div>
  );
};
